



















































































































































































































import { defineComponent, PropType, ref } from "@vue/composition-api";
import OccLabel from "@/components/Atoms/OccLabel/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccStar from "@/components/Atoms/OccStar/index.vue";
import ListTable from "@/components/Molecules/ListTable/index.vue";
import { formatDate } from "@/helpers/date-helper";
import {
  getDisplayEventStatus,
  getDisplayEventType,
  getDisplayScheduleSpan,
  getDisplaySelectionStatus
} from "@/helpers/partnerEntryUsers";
import { ApiResponse } from "@/api/types";
import { useRouter } from "@/router";

export interface Props {
  partnerEntryUsers: ApiResponse.PartnerEntryUser[];
}

export default defineComponent({
  name: "PartnerEntryUsersTable",
  components: {
    OccLabel,
    OccButton,
    OccStar,
    ListTable
  },
  props: {
    partnerEntryUsers: {
      type: Array as PropType<Props["partnerEntryUsers"]>,
      default: () => []
    },
    selectedPartnerEntryUsers: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hasAlert: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const router = useRouter();
    const toggleStar = (rowId: number, value: boolean) => {
      const partnerEntryUser = props.partnerEntryUsers.find(
        v => v.partner_entry_user.id === rowId
      );
      if (!partnerEntryUser) return;

      emit("toggleStar", partnerEntryUser.partner_entry_user.id, value);
    };

    const partnerEntryUserIds = ref<number[]>([]);
    const handleChangeRowValue = (rowValues: number[]) => {
      partnerEntryUserIds.value = rowValues;
    };

    const goToApplicant = (_: Event, index: number) => {
      const partnerEntryUser =
        props.partnerEntryUsers[index].partner_entry_user;
      try {
        const userDetailRoute = router.resolve({
          name: "Applicant",
          params: { user_id: String(partnerEntryUser.user_id) }
        });
        window.open(userDetailRoute.href, "_blank", "noopener");
      } catch (e) {
        return;
      }
    };

    return {
      getDisplayEventStatus,
      getDisplayEventType,
      getDisplaySelectionStatus,
      getDisplayScheduleSpan,
      formatDate,
      toggleStar,
      handleChangeRowValue,
      goToApplicant
    };
  }
});
